import { redirect } from 'react-router-dom';
import type { LoaderFunctionArgs } from 'react-router-dom';
import { apiGet } from '../lib/apiClient.js';
import type { Permission } from '../app/routeTypes.js';

export function permissionLoader(permissions: readonly Permission[]) {
  return async ({ request }: LoaderFunctionArgs) => {
    const response = await apiGet<{ permissions: Permission[] }>('/api/v1/users/me/permissions', {
      signal: request.signal,
      suppressSessionExpired: true,
    });
    const granted = new Set(response.data.permissions);
    const allowed = permissions.every((permission) => granted.has(permission));
    if (!allowed) throw redirect('/access-denied');
    return null;
  };
}
